import React from "react";
import Icon from "./Icon";

// Maps file type/extension to an inline-SVG icon + brand color.
const iconMap = {
  folder: { name: "folder", color: "#f0b429" },
  pdf:    { name: "filePdf", color: "#e5484d" },
  docx:   { name: "fileWord", color: "#1b95a6" },
  doc:    { name: "fileWord", color: "#1b95a6" },
  xlsx:   { name: "fileExcel", color: "#12a150" },
  xls:    { name: "fileExcel", color: "#12a150" },
  pptx:   { name: "filePpt", color: "#f0b429" },
  ppt:    { name: "filePpt", color: "#f0b429" },
  png:    { name: "fileImage", color: "#245a8d" },
  jpg:    { name: "fileImage", color: "#245a8d" },
  jpeg:   { name: "fileImage", color: "#245a8d" },
  gif:    { name: "fileImage", color: "#245a8d" },
  zip:    { name: "fileZip", color: "#667085" },
  txt:    { name: "fileText", color: "#667085" },
  generic:{ name: "file", color: "#667085" },
};

function FileIcon({ type, ext, large }) {
  const key = type === "folder" ? "folder" : (ext || "generic");
  const config = iconMap[key] || iconMap.generic;
  return (
    <Icon
      name={config.name}
      size={large ? 30 : 20}
      className={large ? "gd-file-icon large" : "gd-file-icon"}
      style={{ color: config.color }}
    />
  );
}

export default FileIcon;
